import React from 'react';
import { ConnectionStatusContext } from './connection-status-context';

export function useConnectionStatus() {
    return React.useContext(ConnectionStatusContext);
}
